import type { FunnelData } from '../types/funnel';

/**
 * Owner-authorized promotions: suitable, simple, prepared WEEKDAY moves with 2 movers may be negotiated to
 * $119 → $109 → $99 → final floor $90/h. $90 is never a public or universal rate and never applies to 3 movers.
 * Weekends: 2 movers stay $129/h. 3 movers may be negotiated to $129/h for eligible bookings.
 * The browser never applies a reduced rate: only a server-validated quote ID can carry one.
 */
export const weekdayOffer = { crew: 2 as const, ladder: [119, 109, 99, 90], threeMoverFloor: 129 };

export function isWeekend(date: string): boolean {
  if (!date) return false;
  // Interpret the calendar date itself (service runs on America/New_York dates), independent of device time zone.
  const [y, m, d] = date.split('-').map(Number);
  const day = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return day === 0 || day === 6;
}

/** Shows the "from $99" message only where it could genuinely apply. Eligibility is still confirmed by the team. */
export function offerMayApply(d: FunnelData, crewUsed: number): boolean {
  if (crewUsed !== weekdayOffer.crew) return false;
  if (d.homeType === 'office') return false;
  if (d.packing === 'professional') return false;
  if (!d.bedrooms || !['few', 'studio', '1', '2'].includes(d.bedrooms)) return false;
  const upstairs = (a: FunnelData['origin']) => a.floor !== 'ground';
  if (d.bedrooms === '2' && (upstairs(d.origin) || upstairs(d.destination))) return false;
  if (d.origin.carryBand === 'over_100' || d.destination.carryBand === 'over_100') return false;
  if (d.stops.length > 0) return false;
  return true;
}
